export default "__VITE_ASSET__1f54313d__"